import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import useGraph from './useGraph/useGraph';
import { StyledGraph } from '../ScatterChart.style';

const Graph = ({ data }) => {
  const graphConfig = useGraph({ data });

  return (
    <StyledGraph>
      <HighchartsReact
        containerProps={{ style: { height: '100%', width: '100%' } }}
        highcharts={Highcharts}
        options={graphConfig}
      />
    </StyledGraph>
  );
};

export default Graph;
